import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import * as PhotoSwipe from "photoswipe";
import * as DefaultUiOptions from "photoswipe/dist/photoswipe-ui-default";

const showGallery = (items: PhotoSwipe.Item[], startIndex = 0) => {
  const builder = document.createElement("div");
  builder.innerHTML = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

        <!-- Background of PhotoSwipe. 
             It's a separate element as animating opacity is faster than rgba(). -->
        <div class="pswp__bg"></div>

        <!-- Slides wrapper with overflow:hidden. -->
        <div class="pswp__scroll-wrap">

            <!-- Container that holds slides. 
                PhotoSwipe keeps only 3 of them in the DOM to save memory.
                Don't modify these 3 pswp__item elements, data is added later on. -->
            <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>

            <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
            <div class="pswp__ui pswp__ui--hidden">

                <div class="pswp__top-bar">

                    <!--  Controls are self-explanatory. Order can be changed. -->

                    <div class="pswp__counter"></div>

                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                    

                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                    <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                    <!-- element will get class pswp__preloader--active when preloader is running -->
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                          <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                          </div>
                        </div>
                    </div>
                </div>

                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                </button>

                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                </button>

                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>

            </div>

        </div>

    </div>`;
  const root = builder.firstChild;
  document.body.appendChild(root!);

  const pswp = new PhotoSwipe(root as HTMLElement, DefaultUiOptions, items, {
    index: startIndex,
    arrowEl: false,
  });

  pswp.listen("destroy", function () {
    root?.remove();
  });
  pswp.init();
};
const hookGallery = (article: ParentNode) => {
  const data = JSON.parse((article as HTMLElement).dataset.assets!);
  const buildImage = (id: string, url: string) => {
    const uri = new URL(url);

    const asset = data.find((x) => x.id == id);
    let width = 1920;
    let height = 1080;
    const maxSize = 3200;
    if (asset && asset.width && asset.height) {
      if (asset.width > maxSize || asset.height > maxSize) {
        const maxValue = Math.max(asset.width, asset.height);
        const ratio = maxSize / maxValue;
        asset.width = Math.floor(asset.width * ratio);
        asset.height = Math.floor(asset.height * ratio);
      }

      width = asset.width;
      height = asset.height;
    }

    uri.search = `?width=${width}&height=${height}&bgcolor=000&scale=canvas`;
    return { src: uri.toString(), w: width, h: height };
  };

  const articleImg = article.querySelector<HTMLElement>(".cover-img");

  const elements: HTMLElement[] = [];

  const assets: ReturnType<typeof buildImage>[] = [];

  if (articleImg) {
    const articleImgSrc = articleImg.attributes.getNamedItem("src");
    if (articleImgSrc) {
      elements.push(articleImg);
      assets.push(buildImage(articleImg.dataset.assetid!, articleImgSrc.value));
    }
  }

  const imageElements = article.querySelectorAll<HTMLImageElement>(
    ".article-content img[data-assetid]:not(.hide-from-gallery)"
  );
  imageElements.forEach((x) => {
    elements.push(x);
    assets.push(buildImage(x.dataset.id!, x.dataset.src!));
  });

  elements.forEach((el, i) => {
    el.classList.add("cursor-pointer");
    el.classList.add("max-width-full");
    el.addEventListener("click", () => {
      showGallery(assets, i);
    });
  });
};

export { hookGallery };
